import { apiGet, apiPost } from '../ApiClient';

/**
 * Fetch customers matching a search term.
 * Uses the standard Frappe resource API.
 *
 * @param {string} searchTerm - Partial name / ID to filter by
 * @returns {Promise<Array>} Array of { name, customer_name, loyalty_program }
 */
export async function fetchCustomers(searchTerm = '') {
  const filters = searchTerm
    ? JSON.stringify([
        ['customer_name', 'like', `%${searchTerm}%`],
      ])
    : undefined;

  const res = await apiGet('resource/Customer', {
    fields: JSON.stringify(['name', 'customer_name', 'loyalty_program']),
    filters,
    limit_page_length: 20,
    order_by: 'customer_name asc',
  });
  return res?.data || [];
}

/**
 * Fetch a single customer record by name.
 */
export async function fetchCustomer(name) {
  const res = await apiGet(`resource/Customer/${name}`);
  return res?.data;
}

/**
 * Create a new customer from the POS.
 *
 * @param {Object} params
 * @param {string} params.customerName - Display/customer name
 * @param {string} [params.mobileNo] - Optional mobile number
 * @param {string} [params.emailId] - Optional email
 * @returns {Promise<Object>} Created Customer document
 */
export async function createCustomer({ customerName, mobileNo, emailId }) {
  const payload = {
    doctype: 'Customer',
    customer_name: customerName,
    customer_type: 'Individual',
  };

  if (mobileNo) payload.mobile_no = mobileNo;
  if (emailId) payload.email_id = emailId;

  const res = await apiPost('resource/Customer', payload);
  return res?.data;
}
